import React, { useEffect} from "react";
import Notification from "./Notification";
import {remove} from "@/reducers/NotificationReducer";
import store from "@/redux/store";

export function NotificationHolder({...props}) {
    
    
    const closeNotificationHandler=((message) => {
        store.dispatch(remove({message: message}));
    })    
   return (
    <>
        <div className="absolute top-5 right-5 min-w-96">
    {props.notifications && props.notifications.map((item) => { 
        //store.dispatch(remove({message: item}));
        return (
        <Notification data={item} notifications={props.notifications} closeNotificationEvent={closeNotificationHandler}/>) 
    })
    }
        </div>
    </>
    )    
}